<template>
  <div>
        <p class="p-3 text-lg font-bold "><span class="typcn typcn-edit"></span> List Cabang Toko</p>
    <hr class="mt-1 mb-1">
    <form  @submit.prevent="submit">
      <div class="row justify-content-center">
        <div class="col-6 p-2" style="font-size:12px;">
          <div class="shadow p-3 rounded-lg bg-white">
          <!-- INPUT -->
          <div class="sm-form">
            <input
              type="text"
              id="id"
              name="id"
              class="form-control form-control-sm"
              placeholder="id"
              v-model="datacabang.id"
              disabled
            />
          </div>
          <div class="table-responsive">
              <table class="table table-sm table-striped table-bordered">
                   <tr>        
                      <td class="capitalize">Nama Cabang</td>
                      <td class="pl-2 pr-2">:</td>
                      <td>
                          <div class="sm-form ">
                              <input type="text" id="cabang" name="cabang" class="form-control form-control-sm" placeholder="cabang" v-model="datacabang.cabang" >
                          </div>
                      </td>
                  </tr>
                   <tr>        
                      <td class="capitalize">alamat</td>
                      <td class="pl-2 pr-2">:</td>
                      <td>
                          <div class="sm-form">
                          <textarea
                          type="text"
                          id="alamat"
                          name="alamat"
                          rows="2"
                          placeholder="alamat..."
                          class="form-control md-textarea"
                          v-model="datacabang.alamat"
                          ></textarea>
                          </div>
                      </td>
                  </tr>
                   <tr>        
                      <td class="capitalize">No Hp</td>
                      <td class="pl-2 pr-2">:</td>
                      <td>
                          <div class="sm-form ">
                              <input type="nohp" id="nohp" name="nohp" class="form-control form-control-sm" placeholder="nohp" v-model="datacabang.nohp" >
                          </div>
                      </td>
                  </tr>
              </table>

          </div>
          <!-- END INPUT -->
          <!-- BUTTON PART -->
          <div class="mt-3 p-3">
            <button
              type="submit"
              class="btn btn-sm"
              :class="
                btn == 'tambah'
                  ? 'btn-primary'
                  : btn == 'update'
                  ? 'btn-success'
                  : 'btn-danger'
              "
            >
              <span class="typcn typcn-info"></span> Proses  {{ btn }}
            </button>
            <div class="float-right">
              <button
                type="button"
                v-show="btn!='tambah'"
                @click="
                  btn = 'tambah';
                  datacabang = {};
                "
                class="btn btn-sm btn-dark"
              >
                <span class="typcn typcn-edit"></span> Tambah
              </button>
              <button
                type="button"
                @click="btn = 'delete'"
                v-show="btn!='tambah'"
                class="ml-3 btn btn-sm btn-danger"
              >
                <span class="typcn typcn-delete"></span> Delete
              </button>
            </div>
          </div>
          </div>
          <!-- END BUTTON PART -->
        </div>
        <div class="col-5 p-2" style="font-size:12px;">
          <div class="shadow rounded-lg bg-white">
            <!-- TABLE PART -->
            <div v-if="datanya.length>0" class="p-2">
             <div class="text-right">
                <vue-json-excel :data="datanya">
                  <button type="button" class="btn btn-sm btn-dark">
                    Export <span class="typcn typcn-chart-area"></span>
                  </button>
                </vue-json-excel>
              </div>
                <Btables :tables="datanya"  :cari="['']" :hide="['']" @selected="ambil" ref="btable" />
            </div>
            <!-- END TABLE PART -->
         </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
// TOTURIAL 
// ganti source autophp, ganti source component btable, ganti path table sdb
import autophp from "@/plugins/autophp_kasir.js"; // ganti source nya
import Btables from "@/components/Btables.vue"; //component btable nya
let sdb = new autophp();
export default {
    layout:'app_shop_admin',
  components: {
    Btables,
  },
  data() {
    return {
      selected: false,
      datacabang: {},
      btn: "tambah",
      datanya:[],
    };
  },
  methods: {
    app_kasir_toko_cabang(){
      this.$refs.btable.getData()
    },
    getData(){
      sdb.collection("app_kasir_toko_cabang",false).doc().select(`select * from app_kasir_toko_cabang`).then(res => {
        this.datanya=res;
        this.$forceUpdate();
      });
      
    },
    ambil(data) {
      this.datacabang = data;
      this.btn = "update";
      this.$forceUpdate();
    },
    submit() {
      let that=this
      if (confirm("Apakah yakin proses dilanjutkan ?")) {
        if (this.btn == "tambah") {
          //idnya letak di datacabang
          delete this.datacabang.id;
          sdb
            .collection("app_kasir_toko_cabang")
            .doc()
            .set(this.datacabang)
            .then((res) => {
              that.getData();
            // that.nuxt.emit('getData')

            });
        } else if (this.btn == "update") {
          sdb
            .collection("app_kasir_toko_cabang")
            .doc()
            .set(this.datacabang)
            .then((res) => {
              that.getData();
            // that.nuxt.emit('getData')
            });
        } else if (this.btn == "delete") {
          sdb
            .collection("app_kasir_toko_cabang")
            .doc(this.datacabang.id)
            .delete()
            .then((res) => {
              that.getData();
            // that.nuxt.emit('getData')
            });
        }
        // this.nuxt.emit('getData','ok')
      }
    },
  },
  async mounted() {
    this.getData();
  },
};
</script>